import { Component, OnInit, HostBinding, Input, OnChanges, OnDestroy } from '@angular/core';
import { RanchoService } from '@rancho/rancho.service';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { NgxSpinnerService } from 'ngx-spinner';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { UsuarioService } from '@account/usuario.service';
import { UntypedFormControl } from '@angular/forms';
import { NgbDateStruct, NgbCalendar, NgbModal, NgbDatepickerConfig, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SharedService } from '@shared/shared.service';
import { fadeAnimationTrigger } from '@shared/animations';
import { DatePipe } from "@angular/common";
import { environment } from '@environments';
import { HttpClient } from '@angular/common/http';
import { ModalModificarAerovaleComponent } from '@rancho/modal-modificar-aerovale/modal-modificar-aerovale.component';
import { MessageService } from '@shell/message.service';
import { TipoAerovale } from '@shared/enums/tipoAerovale';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { Remito } from '@shared/models/facturacion/Remito';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { ImporteFactura } from '@shared/models/facturacion/ImporteFactura';
import { EstadoFactura } from '@shared/enums/EstadoFactura';
import { TipoPago } from '@shared/enums/tipoPago';
import { RemitoFox } from '@shared/models/despacho/RemitoFox';
import { ModalCreacionFoxComponent } from '@despacho/modal-creacion-fox/modal-creacion-fox.component';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { AerovaleUpdatedAerocombustibleComponent } from '@despacho/aerovales-update/aerovale-updated-aerocombustible/aerovale-updated-aerocombustible.component';
import { VisorRanchosRemitosComponent } from '@rancho/visor-ranchos-remitos/visor-ranchos-remitos.component'
import { ModalAnulacionAerovaleComponent } from '@despacho/modal-anulacion-aerovale/modal-anulacion-aerovale.component';

@Component({
  selector: 'app-visor-remitos',
  templateUrl: './visor-remitos.component.html',
  styleUrls: ['./visor-remitos.component.css'],
  animations: [fadeAnimationTrigger]
})

export class
  VisorRemitosComponent implements OnInit, OnChanges, OnDestroy {

  @HostBinding('class.changed')

  aeroplantaPuedeFacturar: boolean = false;
  fileAerovaleFisico:File;
  tipoPago = TipoPago;
  TipoUsuario = TipoUsuario;

  importeFactura: ImporteFactura;

  baseUrl = environment.apiServer.baseUrl;
  aerovales: Aerovale[] = [];
  aerovalesFiltrados: Aerovale[] = [];
  aerovaleActual: Aerovale;
  aerovaleDetalle: AerovaleDetalle;
  fechaHasta = new UntypedFormControl();
  fechaFormControlDesdeHasta = new UntypedFormControl();
  model: NgbDateStruct;
  model1: NgbDateStruct;
  time: NgbTimeStruct;
  startDate: Date;
  endDate: Date;
  buscando: boolean = false;
  mensajeSpinner: string = "D e s c a r g a n d o";
  obteniendoAerovales = true;
  obteniendoComprobante = true;
  procesandoExport: boolean = false;
  codigoAeroplanta: string;
  cambiandoAeroplanta: boolean = false;
  verFactura: boolean = false;
  // pendiente = { valor: "Pendiente", descripcion: "Pendiente", seleccionado: false };
  // finalizado = { valor: "Finalizado", descripcion: "Finalizado", seleccionado: false };
  anulado = { valor: "Anulado", descripcion: "Anulado", seleccionado: false };

  aerovaleAerocombustible = { tipo: 0, valor: "AerovaleAerocombustible", descripcion: "Aerovale Aerocombustible", seleccionado: false };
  tipos = [
    this.aerovaleAerocombustible
  ];

  estados = [
    this.anulado
  ];
  busquedaFormControl = new UntypedFormControl();
  change$: Subscription;
  errorAerovales: boolean = false;
  tipoNuevoAerovale: TipoAerovale;
  TipoAerovale = TipoAerovale;
  EstadoAerovale = EstadoAerovale;
  @Input() facturaObtenida: Comprobante;
  remito: Remito;
  botonAnular: boolean = false;

  remitoObtenido: Comprobante;
  remitoFox: RemitoFox;
  buscandoComprobante: boolean = false;
  capturandoAevAnulado: boolean = false;

  subject$: Subscription;

  constructor(private datepickerConfig2: NgbDatepickerConfig,
    private messageService: MessageService,
    private ranchoService: RanchoService,
    private usuarioService: UsuarioService,
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private http: HttpClient,
    private datePipe: DatePipe,
    private modalAnulacion: NgbModal,
    private comprobanteService: ComprobanteService,
    public authService: AuthService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta();
      });
      this.subject$ = this.ranchoService.getArchivoAerovaleAnulado().subscribe((file)=>{
        if (file) {
          this.openModal(file);
        }
      })
  }

  ngOnInit() {
    this.buscandoComprobante = false;
    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.aeroplantaPuedeFacturar = this.usuarioService.getAeroplantaActual().habilitarFacturacion || this.usuarioService.getAeroplantaActual().soloPAD;
    this.botonAnular = false;
    this.mensajeSpinner = "C a r g a n d o . . .";

    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.model.day, month: this.model.month, year: this.model.year };
    this.model1 = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    setTimeout(() => {
      this.spinner.show('spinnerLista');
    });
    this.reinicioFechaInicioFechaFin();
    this.getAerovalesPorRango(this.startDate, this.endDate);
    this.obtenerRemitos();
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  onSelect(aerovale: Aerovale): void {
    this.remitoFox = null;
    this.buscandoComprobante = true;
    this.obteniendoComprobante = true;
    setTimeout(() => {
      this.spinner.show('spinnerLista');
    });
    this.facturaObtenida = null; //inicializo el comprobante en null en cada seleccion
    this.spinner.show('spinnerDetalle');
    this.aerovaleDetalle = null;
    this.aerovaleActual = aerovale;
    this.ranchoService.getAerovalePorIdyTipo(this.aerovaleActual.id)
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;
        console.log(this.aerovaleDetalle);
        this.spinner.hide('spinnerDetalle');
        this.obtenerRemitos();
      });
  }

  aeroplantaSoloPad(){    
    return this.usuarioService.getAeroplantaActual().soloPAD;
  }

  print(): void {
    const printContents = document.getElementById('aerovalePrint').innerHTML;
    this.sharedService.print(printContents);
  }

  filtrarAerovales() {
    this.aerovalesFiltrados = this.aerovales.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.clienteRazonSocial.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;
        agregar = agregar || (a.nombreCiudadAeropuerto &&
          a.nombreCiudadAeropuerto.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.vuelo && a.vuelo.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.matricula && a.matricula.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.numeroAerovale && a.numeroAerovale.toString().indexOf(this.busqueda.value) > -1);
      }
      if (this.estados.some(b => b.seleccionado))
        agregar = agregar && this.estados.some(
          b => (b.seleccionado && b.valor == a.estado));
      if (this.tipos.some(b => b.seleccionado))
        agregar = agregar && this.tipos.some(
          b => (b.seleccionado && b.tipo == a.tipoAerovale));
      return agregar;
    });
    if (this.aerovaleActual) {
      if (!this.aerovalesFiltrados.includes(this.aerovaleActual)) {
        this.aerovaleDetalle = null;
      }
    }
  }

  get busqueda() {
    return this.busquedaFormControl;
  }

  getAerovalesPorRango(fechaInicio: Date, fechaFin: Date) {
    this.obteniendoAerovales = true;
    this.aerovales = [];
    this.aerovalesFiltrados = [];
    this.spinner.show('spinnerLista');
    const desde: string = this.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), 0, 0);
    const hasta: string = this.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), 23, 59);
    this.ranchoService.getAerovalesPorRangoEnAeroplantas(desde, hasta)
      .subscribe(result => {
        this.aerovales = result.sort((a, b) => new Date(b.fechaHoraFinDespacho).getTime() - new Date(a.fechaHoraFinDespacho).getTime());
        this.aerovalesFiltrados = this.aerovales;
        this.spinner.hide('spinnerLista');
        this.spinner.hide('spinnerLista');
        this.obteniendoAerovales = false;
        this.filtrarAerovales();
      }, () => {
        this.errorAerovales = true;
        this.obteniendoAerovales = false;
      });
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  ngOnDestroy() {
    this.change$.unsubscribe(); // cambia aeroplanta
    this.subject$.unsubscribe(); // captura remito
    this.aerovalesFiltrados = [];
  }

  /**
   * Convierte una NgbDateStruct y una NgbTimeStruct en un Date
   */
  dateFromDateTimeStruct(date: NgbDateStruct, hour: NgbTimeStruct): Date {
    if (date == null || hour == null)
      return null;
    const dateReturn = new Date();
    dateReturn.setDate(date.day);
    dateReturn.setMonth(date.month - 1);
    dateReturn.setFullYear(date.year);
    dateReturn.setHours(hour.hour);
    dateReturn.setMinutes(hour.minute);
    return dateReturn;
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    if (this.startDate > this.endDate) { esMayor = true; }
    return esMayor;
  }


  reinicioFechaInicioFechaFin() {
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  buscarDesdeHasta() {
    this.aerovalesFiltrados = null;
    this.aerovaleActual = null;
    this.aerovaleDetalle = null;
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.buscando = true;
    this.reinicioFechaInicioFechaFin();
    if (this.mostrarResultados() === true) {
      this.getAerovalesPorRango(this.startDate, this.endDate);
    }
    else {
      this.aerovalesFiltrados.splice(0, this.aerovalesFiltrados.length);
    }
    this.buscando = false;
  }

  mostrarResultados() {
    let mostrar: boolean;
    mostrar = false;
    mostrar = (this.startDate < this.endDate);
    return mostrar;
  }

  limpiarCampos() {
    this.aerovalesFiltrados = [];
    this.aerovaleDetalle = null;
    this.spinner.hide("spinnerLista");
    this.spinner.hide("spinnerDetalle");
    this.buscando = false;
    this.busquedaFormControl.reset();
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    //limpio filtro estados
    for (const estado of this.estados) {
      estado.seleccionado = false;
    }
    //limpio filtro tipos
    for (const tipo of this.tipos) {
      tipo.seleccionado = false;
    }
  }

  cambiarDeAeroplanta() {
    this.cambiandoAeroplanta = false;
    this.limpiarCampos();
    this.cambiandoAeroplanta = true;
    this.ngOnInit();
  }

  mostrarFactura(content) {
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  anularModificarAerovale(detalle: AerovaleDetalle, esModificacion: boolean) {    
    if(this.aerovaleDetalle.estado == "DespachoIniciado" || this.aerovaleDetalle.estado == "DespachoFinalizado" || this.aerovaleDetalle.estado == "Pendiente"){
      const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true });
      if (!esModificacion){
        modalRef.componentInstance.mensaje = "Esta anulando un aerovale en estado " + this.aerovaleDetalle.estado + ". Este aerovale aún no genero remito de stock ni de facturacion. ¿Esta seguro de anularlo?"; 
      }
      modalRef.result.then(() => {
        this.accionAnularModificarAerovale(detalle, esModificacion);
      });
    }else{
      this.accionAnularModificarAerovale(detalle, esModificacion);
    }
  }

  accionAnularModificarAerovale(detalle: AerovaleDetalle, esModificacion: boolean){
    this.obtenerAerovalePorId(detalle.id);
        const modalRef = this.modalAnulacion.open(esModificacion ? ModalModificarAerovaleComponent : ModalAnulacionAerovaleComponent, { centered: true, size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.detalle = detalle;
        modalRef.result.then(() => {
          this.onSelect(this.aerovaleActual);
        });
  }

  onClickReemplazar() {
    this.capturandoAevAnulado=true;
    this.spinner.show('spinnerDetalle');
    this.ranchoService.setCapturarAerovaleAnulado(true);    
  }

  openModal(file) {
    this.spinner.hide('spinnerDetalle');
    let modalRef;
    if(file != undefined) {
      if(file != undefined) {
        modalRef = this.aerovaleDetalle.tipoAerovale === TipoAerovale.Aerocombustible ? this.modalService.open(AerovaleUpdatedAerocombustibleComponent, { centered: true, size: 'lg', backdrop: 'static' }) :
          this.messageService.showErrorMessage("El tipo aerovale "+TipoAerovale[this.aerovaleDetalle.tipoAerovale]+" no puede modificarse.");
        }
      this.capturandoAevAnulado=false;             
      modalRef.componentInstance.aerovaleReemplaza = this.aerovaleDetalle;
      modalRef.componentInstance.fileAerovaleFisico = file;
      modalRef.result.then((result) => {
        if(result) {
          this.fileAerovaleFisico=null;
          this.onSelect(this.aerovaleActual);
        }
      });
    }else{
      this.messageService.showErrorMessage("El archivo no se capturo correctamente, vuelva intentarlo.");
      this.capturandoAevAnulado=false;
    }    
  }

  obtenerComprobanteIdPorAerovaleId(id: string) {
    this.importeFactura == null;

    this.obteniendoComprobante = true;
    console.log("obtener si tiene un comprobante asociado");
    this.comprobanteService.obtenerComprobanteIdSegunAerovale(id)
      .subscribe(result => {
        this.importeFactura = result;
        if (result == null) {
          this.botonAnular = true;
          this.obteniendoComprobante = false;
        } else {
          this.obtenerComprobantePorId(this.importeFactura.facturaId);
        }
      }, () => {
        this.botonAnular = true;
        this.obteniendoComprobante = false;
      });
  }

  obtenerComprobantePorId(id: string) {
    console.log("obtener el comprobante según id");
    this.comprobanteService.obtenerComprobantePorId(id)
      .subscribe(result => {
        console.log(result);
        this.facturaObtenida = result; //obtengo el comprobante segun id
        this.obteniendoComprobante = false;
      });
  }

  obtenerAerovalePorId(id: string) {
    console.log("obtengo aerovale con id" + id);
    this.aerovaleDetalle = null;
    this.ranchoService.getAerovalePorIdyTipo(id)
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;

      });
  }

  verRemito() {
    if (this.remitoFox.numeroFox != 0 && this.remitoFox.prefijoFox != 0 && this.remitoFox.numeroFox != null && this.remitoFox.prefijoFox != null) {
      const modalRef = this.modalService.open(VisorRanchosRemitosComponent, { centered: true, size: 'lg' });
      modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;
      modalRef.componentInstance.aerovale = this.aerovaleActual;
      modalRef.componentInstance.remitoFox = this.remitoFox;
      modalRef.componentInstance.remitoObtenido = this.remitoObtenido;
    } else {
      const modalRef = this.modalService.open(ModalCreacionFoxComponent, { centered: true });
      modalRef.componentInstance.remitoFox = this.remitoFox;
      modalRef.result.then((result) => {
        if (result) {
          this.verRemito();
        }
      });
    }
  }

  obtenerRemitos() {
    this.buscandoComprobante = true;
    if (this.aerovaleActual != null) {
      this.comprobanteService.getRemitoAerovale(this.aerovaleActual.id)
        .subscribe(result => {
          this.remitoFox = result;
          this.buscandoComprobante = false;
          this.obtenerComprobanteIdPorAerovaleId(this.aerovaleDetalle.id);
        }, () => {
          this.messageService.showErrorMessage('Hubo un error al obtener el remito de facturación');
          this.buscandoComprobante = false;
          this.obtenerComprobanteIdPorAerovaleId(this.aerovaleDetalle.id);
        });
    }
  }

  rolesParaAnularOk(){
    return this.authService.hasRole(TipoUsuario.SUPERVISOR, TipoUsuario.OPERADOR, TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.TUTOR, TipoUsuario.MANDATARIO, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN);
  }

  verificarEstadoFactura(): boolean {
    let visualizar: boolean = false;
    visualizar = this.facturaObtenida != null && this.facturaObtenida.factura.estado == EstadoFactura.Emitido;
    if (visualizar === true) {
      this.verFactura = true;
    }
    return visualizar;
  }

  logicaParaMostrarBotonAnularAerovaleOk(){
    if(this.aerovaleDetalle.estado == 'Anulado'){
      return false;
    }

    if(this.aerovaleDetalle.estado == "DespachoIniciado" || this.aerovaleDetalle.estado == "DespachoFinalizado" || this.aerovaleDetalle.estado == "Pendiente"){
      return true;
    }

    if(this.aerovaleDetalle.estado == "FinalizadoSinFirma" || this.aerovaleDetalle.estado == "Finalizado" || this.aerovaleDetalle.estado == "Sincronizado"){
      /*Si es FinSinFirma, FinConFirma o sincronizado chequear que esta facturado.
	    Que este facturado significa que al obtener obtenerComprobanteIdPorAerovaleId, el atributo facturado del dto respuesta
      sea true y tener atributo facturaId != null. 
      */
      if(this.importeFactura == null || (this.importeFactura.facturaId != null && this.importeFactura.estado != EstadoFactura.Emitido)){
        return true;
      }
    }

    return false;
  }

  usuarioCapturoAerovale(fileAerovaleFisico: File) {
    this.fileAerovaleFisico = fileAerovaleFisico;
  }
}
